export default class PredictorBadgeRequirements {
  public predictionsNumber: number;
  public correctPredictions: number;
  public points: number;
  public fromDate: string;
  public toDate: string;
}
